import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ModeloRelatorio } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ModeloRelatorioService extends BaseResourceService<ModeloRelatorio> {

  constructor(
    protected injector: Injector
  ) {
    super(`modelos-relatorio`, injector);
  }

}
